export const ordenPaises = {
  especiales: 0,
  qatar: 1,
  ecuador: 2,
  senegal: 3,
  holanda: 4,
  inglaterra: 5,
  iran: 6,
  eeuu: 7,
  gales: 8,
  argentina: 9,
  "arabia saudita": 10,
  mexico: 11,
  polonia: 12,
  francia: 13,
  australia: 14,
  dinamarca: 15,
  tunez: 16,
  españa: 17,
  "costa rica": 18,
  croacia: 19,
  alemania: 20,
  japon: 21,
  belgica: 22,
  canada: 23,
  marruecos: 24,
  croacia: 25,
  brasil: 26,
  serbia: 27,
  suiza: 28,
  camerun: 29,
  portugal: 30,
  ghana: 31,
  uruguay: 32,
  "corea del sur": 33,
};
